var dateTimePicker = {

	elms: {
		datePicker: $('.datepicker'),
		timePicker: $('.timepicker')
	},

	addDatePicker: function() {
		dateTimePicker.elms.datePicker.datepicker({
			dateFormat: 'dd-mm-yy'
		});
		dateTimePicker.elms.datePicker.datepicker('setDate', new Date());
	},

	addTimePicker: function() {
		dateTimePicker.elms.timePicker.timepicker({
			'timeFormat': 'H:i'
		});
		dateTimePicker.elms.timePicker.timepicker('setTime', new Date());
	},

	init: function() {
		if ( dateTimePicker.elms.datePicker.length > 0 ) {
			dateTimePicker.addDatePicker();
		}
		if ( dateTimePicker.elms.timePicker.length > 0 ) {
			dateTimePicker.addTimePicker();
		}
	}
};
